module.exports = __webpack_public_path__ + "assets/panels/powermaster-360-f21f6a44bfc134cfbc90cc3680026560.svg";